<!--
 * @Date: 2021-07-23 09:33:40
 * @LastEditTime: 2021-07-29 16:50:05
 * @Description: 示范园区子页
 * @FilePath: \shangwu_web\src\views\demonstration\map\parksMap.vue
-->
<template>
  <div class="demo-creation">
    <div id="map" ref="map"></div>
    <div class="panel">
      <div class="title">
        <div class="title-l">
          <span>{{ areaName }}</span>
          共
          <span>{{ totalCount }}</span>
          个
          <span>{{ parkName }}</span>
        </div>
        <div class="title-r el-icon-circle-close" @click="closePanel"></div>
      </div>
      <table class="base-list">
        <thead>
          <tr>
            <td>序号</td>
            <td>{{ colName }}名称</td>
            <td v-if="(isPark && type === '2') || (!isPark && type === '1') || (!isPark && type === '2')"></td>
            <td v-else>增补</td>
            <td>操作</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in demoList" :key="item.id">
            <td>{{ index + 1 }}</td>
            <td>
              <a @click="navToPark(item)">{{
                isPark
                  ? showcontent(item.industrialName)
                  : showcontent(item.title)
              }}</a>
            </td>
            <td v-if="(isPark && type === '2') || (!isPark && type === '1') || (!isPark && type === '2')"></td>
            <td v-else>
              {{
                isBatch ? item.batch : `${item.annual.replace(",", "-")}年度`
              }}
            </td>
            <td><a @click="navToPark(item)">查看</a></td>
          </tr>
        </tbody>
      </table>
      <el-pagination
        layout="prev, pager, next"
        :total="totalCount"
        :page-size="queryInfo.limit"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script scoped>
import mapJson from "../../../store/anhuiMap.json";
import mapLatitude from "../../../store/langAndlati.js";
import cityCode from "../../../store/cityCode.js";
import * as echarts from "echarts";
import {
  parkList,
  parksNum,
  enterpriseNum,
  enterpriseList,
} from "@/apis/apis.js";
import { showcontent } from "../../../utils/method.js";
export default {
  name: "parksMap",
  data() {
    return {
      //地图json文件
      map: mapJson,
      totalCount: 0,
      page: 1,
      lists: [],
      // 年度
      annual: "",
      // 国家/省级产业园区数量
      parkNumList: [],
      mapData: [],
      type: "",
      // 判断是产业园区还是示范企业接口
      isPark: true,
      // 底部面板数据列表
      demoList: [],
      queryInfo: {
        page: 1,
        limit: 4,
      },
      // panel面板title的区域名称
      areaName: "安徽省",
      //城市编码
      cityCode: null,
    };
  },
  filters: {
    // 日期格式化函数
    formatTime: function (date) {
      return date.split(" ")[0];
    },
  },
  computed: {
    // 计算当前页企业或者园区的类型
    parkName() {
      if (this.isPark && this.type === "1") {
        return "国家级电子商务示范基地";
      } else if (this.isPark && this.type === "2") {
        return "安徽省电子商务示范园区";
      } else if (!this.isPark && this.type === "1") {
        return "国家级电子商务示范企业";
      } else if (!this.isPark && this.type === "2") {
        return "安徽省电子商务示范企业";
      } else {
        return "国家级数字商务企业";
      }
    },
    colName() {
      if (this.isPark && this.type === "1") {
        return "基地";
      } else if (this.isPark && this.type === "2") {
        return "园区";
      } else if (!this.isPark && this.type === "1") {
        return "企业";
      } else if (!this.isPark && this.type === "2") {
        return "企业";
      } else {
        return "企业";
      }
    },
    isBatch() {
      if (this.parkName === "国家级电子商务示范基地") return true;
      if (this.parkName === "国家级数字商务企业") return true;
      else return false;
    },
  },
  methods: {
    showcontent,
    // changepage(e){
    //   console.log('1')
    //   this.page=e
    //   let str=''
    //   let newarr=[]
    //   let list=JSON.parse(JSON.stringify(this.lists))
    //   if(this.lists.length>(this.page*5)){
    //     newarr=list.splice((this.page-1)*5,5)
    //   }else{
    //     newarr=list.splice((this.page-1)*5)
    //   }
    //   str+=`<table id='table' cellpadding='0' cellspacing='0' style="width: 4rem; font-size:0.16rem;margin-top:0.1rem;  border-radius: 0.1rem;border:1px solid #91bef9;overflow:hidden;box-sizing: border-box;" >
    //             <tr style="background-color:#91bef9;color:#fff;height:0.5rem;">
    //             <td style="border:1px solid #91bef9;">序号</td>
    //             <td style="border:1px solid #91bef9;">基地名称</td>
    //             <td style="border:1px solid #91bef9;">批次</td>
    //             <td style="border:1px solid #91bef9;border-right:none"">操作</td>
    //             </tr>`
    //   newarr.forEach((item,index)=>{
    //     item.createTime=new Date(item.createTime).getFullYear()+'年'+(new Date(item.createTime).getMonth()+1+'').padStart(2,0)+'月'
    //     str+=`<tr style="color:#fff;height:0.5rem;border:1px solid #91bef9;">
    //             <td style="border:1px solid #91bef9;border-left:none">${index+1}</td>
    //             <td style="border:1px solid #91bef9;">${item.industrialName}</td>
    //             <td style="border:1px solid #91bef9;">${item.createTime}</td>
    //             <td style="border:1px solid #91bef9;border-right:none""><a href='javascript:;' style='text-decoration: none;color:#fff' onclick=navToPark(${item.id})>查看</a></td>
    //             </tr>`
    //   })
    //   str+=`</table>`
    //   document.getElementById('table').innerHTML=str
    // },
    // changepages(e){
    //   console.log('2')
    //   this.page=e
    //   let str=''
    //   let newarr=[]
    //   let list=JSON.parse(JSON.stringify(this.lists))
    //   if(this.lists.length>(this.page*5)){
    //     newarr=list.splice((this.page-1)*5,5)
    //   }else{
    //     newarr=list.splice((this.page-1)*5)
    //   }
    //   str+=`<table id='table' cellpadding='0' cellspacing='0' style="width: 6rem; font-size:0.2rem;margin-top:0.1rem;  border-radius: 0.1rem;border:1px solid #91bef9;overflow:hidden;box-sizing: border-box" >
    //             <tr style="background-color:#91bef9;color:#fff;height:0.5rem;">
    //             <td style="border:1px solid #91bef9;">序号</td>
    //             <td style="border:1px solid #91bef9;">基地名称</td>
    //             <td style="border:1px solid #91bef9;">批次</td>
    //             <td style="border:1px solid #91bef9;border-right:none"">操作</td>
    //             </tr>`
    //   newarr.forEach((item,index)=>{
    //     item.createTime=new Date(item.createTime).getFullYear()+'年'+(new Date(item.createTime).getMonth()+1+'').padStart(2,0)+'月'
    //     str+=`<tr style="color:#fff;height:0.5rem;border:1px solid #91bef9;">
    //             <td style="border:1px solid #91bef9;border-left:none">${index+1}</td>
    //             <td style="border:1px solid #91bef9;">${item.title}</td>
    //             <td style="border:1px solid #91bef9;">${item.createTime}</td>
    //             <td style="border:1px solid #91bef9;border-right:none""><a href='javascript:;' style='text-decoration: none;color:#fff' onclick=navToenterprise(${item.id})>查看</a></td>
    //             </tr>`
    //   })
    //   str+=`</table>`
    //   document.getElementById('table').innerHTML=str
    // },
    navToenterprise(id) {
      this.$router.push({ name: "detailPageInfo", query: { id } });
    },
    navToPark(res) {
      console.log(res);
      if (res.title)
        this.$router.push({ name: "detailPageInfo", query: { id: res.id } });
      else this.$router.push({ name: "detailPark", query: { id: res.id } });
    },
    leftCenterMap() {
      let that = this;
      var myChart = echarts.init(document.getElementById("map")); // 拿到一个实例
      echarts.registerMap("安徽省", mapJson, {}); //引入地图文件

      const mapOption_1 = {
        geo: [
          {
            map: "安徽省",
            layoutSize: "100%",
            silent: true,
            roam: false,
            itemStyle: {
              normal: {
                areaColor: "transparent",
                shadowColor: "transparent",
                shadowBlur: 0,
                shadowOffsetX: 0,
                shadowOffsetY: 0,
                borderColor: "transparent",
                borderWidth: 0,
              },
              emphasis: {
                itemStyle: {
                  areaColor: "transparent",
                  borderWidth: 0,
                },
                label: {
                  show: false,
                },
              },
            },
          },
        ],

        series: [
          {
            type: "map",
            map: "安徽省",
            top: 91,
            bottom: 106,
            left: 198,
            itemStyle: {
              borderColor: "#2ab8ff",
              borderWidth: 0,
              areaColor: "transparent",
              emphasis: {
                areaColor: "transparent",
                borderColor: "#2ab8ff",
                borderWidth: 0.5,
                shadowColor: "rgba(0, 255, 255, 0.7)",
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowOffsetY: 1,
                label: {
                  show: true,
                  fontSize: 14,
                  fontWeight: 400,
                  color: "rgba(127, 197, 197, 1)",
                },
              },
            },
            select: {
              itemStyle: {
                areaColor: "transparent",
                borderColor: "transparent",
                borderWidth: 0,
                shadowColor: "transparent",
                shadowBlur: 0,
                shadowOffsetX: 0,
                shadowOffsetY: 0,
              },
              label: {
                show: false,
              },
            },
            label: {
              show: true,
              formatter: function (params) {
                if (params.data) {
                  return "";
                } else {
                  return params.name;
                }
              },
              fontSize: 14,
              fontWeight: 400,
              color: "rgba(127, 197, 197, 1)",
            },
            data: that.mapData,
          },
          {
            name: "安徽省",
            tooltip: {
              show: false,
            },
            type: "effectScatter",
            coordinateSystem: "geo",
            rippleEffect: {
              scale: 10,
              brushType: "stroke",
              color: {
                type: "radial",
                x: 0.5,
                y: 0.5,
                r: 0.5,
                colorStops: [
                  {
                    offset: 0,
                    color: "#ffff00", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#ff9000", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
            showEffectOn: "render",
            itemStyle: {
              normal: {
                shadowColor: "#0ff",
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowOffsetY: 0,
              },
            },
            label: {
              normal: {
                color: "#fff",
              },
            },
            symbol: "circle",
            symbolSize: [10, 5],
            data: that.mapData,
            zlevel: 6,
          },
          {
            type: "scatter",
            coordinateSystem: "geo",
            label: {
              normal: {
                show: true,
                formatter: function (params) {
                  let name = params.name;
                  let value = params.data.datas;
                  let text = `{fline|${name}}\n{tline|${value}}`;
                  return text;
                },
                color: "#fff",
                align: "center",
                rich: {
                  fline: {
                    padding: [0, 25],
                    color: "#fff",
                    textShadowColor: "#030615",
                    textShadowBlur: "0",
                    textShadowOffsetX: 1,
                    textShadowOffsetY: 1,
                    fontSize: 14,
                    fontWeight: 400,
                  },
                  tline: {
                    padding: [5, 27],
                    color: "#fff",
                    fontSize: 18,
                  },
                },
              },
              emphasis: {
                show: true,
              },
            },
            itemStyle: {
              color: "#00FFF6",
            },
            symbol: `image://${require("@imgs/pages/services/position.png")}`,
            symbolSize: [100, 100],
            symbolOffset: [0, -50],
            z: 999,
            data: that.mapData,
          },
        ],
        visualMap: {
          min: 0,
          max: 1000,
          left: 26,
          bottom: 40,
          showLabel: !0,
          text: ["高", "低"],
          pieces: [
            {
              gt: 0,
              label: "",
              // color: "rgba(109, 190, 176, .5)"
              color: "rgba(49, 77, 155, 0.6)",
            },
            {
              gt: 0,
              lt: 0,
              color: "black",
            },
          ],
          show: false,
        },
      };

      myChart.setOption(mapOption_1);
      myChart.off("click");
      // myChart.off('mouseout');
      myChart.on("click", function (params) {
        myChart.dispatchAction({
          type: "mapUnSelect",
        });
        // console.log(params);
        if (!(params.data && params.data.cityCode)) return;
        // 点击某个城市，将面板上的地区换成相应的城市
        that.areaName = params.data.name;
        that.cityCode = params.data.cityCode;
        console.log("1234", this.cityCode);
        that.getAllCityList(params.data.cityCode);
        // 点击某个城市，底部面板出现
        const panel = document.querySelector(".panel");
        panel.classList.remove("close-panel");
      });
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    },

    renderEcharts() {
      // 新建一个promise对象
      let newPromise = new Promise((resolve) => {
        resolve();
      });
      //然后异步执行echarts的初始化函数
      newPromise.then(() => {
        //	此dom为echarts图标展示dom
        this.leftCenterMap();
      });
    },
    // 获取年度
    getAnnual() {
      let dateYear = new Date().getFullYear() - 1;
      this.annual = dateYear - 1 + "," + dateYear;
    },
    // 获取各个城市示范园区数量
    getParksNum(type) {
      this.cityCode = null;
      this.$ajaxGet(parksNum, { type }).then(({ data }) => {
        if (data.code === 0) {
          this.mapData = [];
          this.type = type;
          // 判断是示范企业还是产业园区
          this.isPark = true;
          this.areaName = "安徽省";
          data.data.forEach((item) => {
            let obj = {
              name: item.cityName,
              value: mapLatitude[item.cityName],
              img: `image://${require("@imgs/pages/services/position_02.png")}`,
              datas: item.cityCount,
              cityCode: cityCode[item.cityName],
            };
            this.mapData.push(obj);
          });
          this.renderEcharts();
          this.getAllCityList();
        }
      });
    },
    // 获取各个城市示范企业数量
    getEnterpriseNum(type) {
      this.cityCode = null;
      this.$ajaxPost(enterpriseNum, {}, { type }).then(({ data }) => {
        if (data.code === 0) {
          this.mapData = [];
          this.type = type;
          this.isPark = false;
          this.areaName = "安徽省";
          data.data.forEach((item) => {
            let obj = {
              name: item.var_name,
              value: mapLatitude[item.var_name],
              img: `image://${require("@imgs/pages/services/position_02.png")}`,
              datas: item.cityCount,
              cityCode: cityCode[item.var_name],
            };
            this.mapData.push(obj);
          });
          this.renderEcharts();
          this.getAllCityList();
        }
      });
    },
    // 实例创建时获取所有城市示范创建数据
    getAllCityList(code, page) {
      // this.queryInfo.page = 1
      // console.log(page,'234')
      // this.cityCode = null
      if (
        page === undefined ||
        page > this.totalCount / this.queryInfo.limit + 1
      )
        this.queryInfo.page = 1;
      else this.queryInfo.page = page;
      this.type = this.type || "1";
      let cityCode = code || "";
      this.$ajaxPost(
        `${this.isPark ? parkList : enterpriseList}?type=${
          this.type
        }&&cityCode=${cityCode}`,
        this.queryInfo
      ).then(({ data }) => {
        if (data.code === 0) {
          this.demoList = data.data.list;
          this.totalCount = data.data.totalCount;
        }
      });
      // this.cityCode = null
    },
    // panel面板页数改变触发事件
    handleCurrentChange(val) {
      // console.log(val)
      // this.queryInfo.page = val;
      // console.log('当前页数是',this.queryInfo.page)
      console.log("当前城市编码", this.cityCode);
      this.getAllCityList(this.cityCode, val);
    },
    // 点击关闭按钮关闭面板
    closePanel() {
      const panel = document.querySelector(".panel");
      panel.classList.add("close-panel");
    },
  },

  mounted() {
    this.getParksNum("1");
    this.getAllCityList();
  },
  created() {
    let _this = this;
    window.navToPark = _this.navToPark;
    window.changepage = _this.changepage;
    window.changepages = _this.changepages;
    window.navToenterprise = _this.navToenterprise;
    this.getAnnual();
  },
};
</script>

<style lang="less" scoped>
@media all and (min-width: 750px) {
  .demo-creation {
    position: relative;
    height: 100%;
    height: 100%;
    color: #314d9b;
    background: url("~@imgs/pages/demonstration/bc.png");
    .panel {
      padding: 0.171875rem;
      position: absolute;
      bottom: 0;
      left: 0.34375rem;
      right: 0.34375rem;
      height: 2.578125rem;
      background-color: rgba(1, 25, 69, 0.6);
      border-radius: 0.06875rem 0.06875rem 0 0;
      box-sizing: border-box;
      transition: all 1s;
      .title {
        display: flex;
        justify-content: space-between;
        font-size: 0.154687rem;
      }
      .title-l {
        height: 0.34375rem;
        line-height: 0.34375rem;
        // color: rgba(184, 179, 179, 0.883);
        color: #fff;
        background-image: linear-gradient(
          to right,
          #3f8af4 0%,
          transparent 100%
        );
        span {
          &:nth-child(2) {
            font-size: 0.257812rem;
          }
          &:nth-child(3) {
            background-image: -webkit-linear-gradient(
              left,
              #fff,
              rgba(184, 179, 179, 0.883)
            );
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
        }
      }
      .title-r {
        width: 0.34375rem;
        height: 0.34375rem;
        line-height: 0.34375rem;
        color: rgba(184, 179, 179, 0.883);
        font-size: 0.257812rem;
        cursor: pointer;
      }
      .base-list {
        margin-top: 0.171875rem;
        width: 100%;
        color: #fefeff;
        font-size: 0.1375rem;
        border-collapse: collapse;

        thead {
          font-size: 0.154687rem;
          tr {
            height: 0.309375rem;
            line-height: 0.309375rem;
            border: 1px solid rgba(64, 138, 243, 0.6);
          }
        }
        td {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        tbody {
          border: 1px solid rgba(64, 138, 243, 0.6);
          tr {
            height: 0.266406rem;
            line-height: 0.266406rem;
            &:hover {
              background-image: linear-gradient(
                0deg,
                rgba(63, 138, 244, 0.35) 0%,
                rgba(63, 138, 244, 0.15) 65%,
                rgba(63, 138, 244, 0.1) 83%,
                rgba(63, 138, 244, 0.35) 100%
              );
            }
          }
          a {
            cursor: pointer;
          }
        }
      }
      /deep/ .el-pagination {
        margin-top: 0.128906rem;
        justify-content: center;
        .btn-next,
        .btn-prev {
          padding: 0;
          height: 0.275rem;
          width: 0.275rem;
          background-color: rgba(63, 138, 244, 0.05);
          border-radius: 4px;
          .el-icon {
            color: #fff;
          }
        }
        .number {
          background-color: rgba(63, 138, 244, 0.05) !important;
        }
        .active {
          background-color: #3f8af4 !important;
          border-radius: 4px;
        }

        .el-pager li {
          margin: 0 0 0 0.1rem;
          width: 0.275rem;
          height: 0.275rem;
          line-height: 0.275rem;
          &:last-child {
            margin-right: 0.1rem;
          }
        }
      }
      &.close-panel {
        animation: 1s close;
        animation-fill-mode: forwards;
      }
    }
  }
  @keyframes close {
    0% {
      transform: translateY(0);
    }
    100% {
      transform: translateY(100%);
    }
  }
  #map {
    width: 100%;
    height: 100%;
  }
}
@media screen and (max-width: 750px) {
}
</style>